import { configureStore, AnyAction } from '@reduxjs/toolkit';
import {
  connectRouter,
  RouterState,
  routerMiddleware,
} from 'connected-react-router';
import history from './history';
import { Reducer } from 'react';
import appSlice from '../features/App/App.slice';
import testResults from '../features/TestResults/TestResults.slice';
import languageSlice from '../features/LanguageProvider/LanguageProvider.slice';

import createSagaMiddleware from 'redux-saga';
import rootSaga from './rootSaga';
import profileSlice from '../features/Profile/Profile.slice';
import questionnairesSlice from '../features/Questionnaires/Questionnaires.slice';
import spacesSlice from '../features/Spaces/Spaces.slice';
import usersSlice from '../features/Users/Users.slice';
import spreadsheetSlice from '../features/Spreadsheet/Spreadsheet.slice';
import questionnairesDetailSlice from '../features/Questionnaires/QuestionnairesDetail/QuestionnairesDetail.slice';
import questionnairesListSlice from '../features/Questionnaires/QuestionnairesList/QuestionnairesList.slice';
import groupsSlice from '../features/Groups/Groups.slice';
import settingsSlice from '../features/Settings/Settings.slice';
import qualificationSlice from '../features/Qualification/Qualification.slice';
import homepageSlice from '../features/HomePage/HomePage.slice';
import achievementsSlice from '../features/Achievements/Achievements.slice';
import siteOwnerTestresultsSlice from '../features/SiteOwnerTestResults/SiteOwnerTestResults.slice';
import testTypesSlice from '../features/TestTypes/TestTypes.slice';
import SettingsSlice from '../features/Settings/Settings.slice';
import WorldRecordsSlice from '../features/WorldRecords/WorldRecords.slice';

const sagaMiddleware = createSagaMiddleware();

// state sanitizer for devTools
const stateSanitizer = (state: any) => {
  return {
    ...state,
  };
};

const store = configureStore({
  reducer: {
    // prettier-ignore
    router: connectRouter(history) as Reducer<RouterState | undefined, AnyAction>,
    app: appSlice,
    profile: profileSlice,
    questionnaires: questionnairesSlice,
    groups: groupsSlice,
    questionnairesList: questionnairesListSlice,
    questionnairesDetail: questionnairesDetailSlice,
    spaces: spacesSlice,
    users: usersSlice,
    homepage: homepageSlice,
    testResults: testResults,
    siteownertestresults: siteOwnerTestresultsSlice,
    settingsSlice: settingsSlice,
    language: languageSlice,
    spreadsheet: spreadsheetSlice,
    qualification: qualificationSlice,
    achievements: achievementsSlice,
    testTypes: testTypesSlice,
    settings: SettingsSlice,
    worldrecords: WorldRecordsSlice,
  },
  middleware: [routerMiddleware(history), sagaMiddleware],
  devTools:
    process.env.NODE_ENV !== 'production'
      ? {
          stateSanitizer,
        }
      : false,
});

sagaMiddleware.run(rootSaga);

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
